/* 🤖 this file was generated by svg-to-ts */
export const DfIconStar16: {
  name: 'star-16';
  data: string;
} = {
  name: 'star-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="m7.441 14.148-3.07 1.707A1.152 1.152 0 0 1 2.8 15.4a1.167 1.167 0 0 1-.13-.749l.614-3.784a1.166 1.166 0 0 0-.313-.998L.328 7.144a1.166 1.166 0 0 1 .02-1.642c.173-.17.394-.28.633-.317l3.554-.546c.38-.058.707-.304.871-.654L6.954.668a1.153 1.153 0 0 1 2.092 0l1.548 3.317c.163.35.49.596.871.654l3.554.546a1.16 1.16 0 0 1 .652 1.96l-2.643 2.724a1.166 1.166 0 0 0-.313.998l.614 3.784a1.16 1.16 0 0 1-.955 1.334 1.15 1.15 0 0 1-.744-.13l-3.071-1.707a1.15 1.15 0 0 0-1.118 0z" fill-rule="evenodd"/></svg>`
};
